import axios from 'axios'
import MediaResponse from '../models/from-api-response/media'
import { MediaFromResponse } from '../models/from-api-response/media'

const sambaVideosApiBaseUrl = 'https://api.spalla.io/v1'

const getMedias = async (filters?: object) => {
	const medias = (
		await axios.get<MediaResponse>(`${sambaVideosApiBaseUrl}/videos`, {
			params: filters,
			headers: {
				Authorization: `Bearer ${process.env.REACT_APP_SAMBA_ACCESS_TOKEN}`,
			},
		})
	).data

	return medias
}

const getMedia = async (mediaId: string) => {
	const media = (
		await axios.get<MediaFromResponse>(`${sambaVideosApiBaseUrl}/videos`, {
			headers: {
				Authorization: `Bearer ${process.env.REACT_APP_SAMBA_ACCESS_TOKEN}`,
			},
		})
	).data

	return media
}

export { getMedias, getMedia }
